import { render } from "./EventManagerComponent.vue?vue&type=template&id=00300438"
import script from "./EventManagerComponent.vue?vue&type=script&lang=js"
export * from "./EventManagerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__